import React from 'react';
import { View, StyleSheet } from 'react-native';
import Colors from '../../constants/Colors';
import { FontAwesome } from '@expo/vector-icons';
import Svg, { Path } from 'react-native-svg';

const ProjectLockOverlay = ({ stage, size }) => {
  if (stage === 'In-Dispute' || stage === 'Court/Arbitration') {
    return (
      <View style={styles.iconContainer}>
        <Svg
          viewBox="0 0 275 318"
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit={1.5}
          width="100"
          height="100"
        >
          <Path
            d="M1031.7 279.367c0-6.874-2.99-13.265-7.92-16.927-20.48-15.23-75.165-55.888-96.891-72.04-5.544-4.123-12.604-4.096-18.127.067l-95.446 71.959c-4.873 3.673-7.822 10.03-7.822 16.859v195.24a20 20 0 0020 20H1011.7a20 20 0 0020-20V279.367z"
            fill="#0a13aa"
            fillOpacity={0.67}
            stroke="#91b7fe"
            strokeWidth={6.4}
            transform="matrix(1.18129 0 0 1 -948.025 -180.148)"
          />
        </Svg>
        <FontAwesome name="lock" size={60} color={Colors.lightBlue2} style={styles.lockIcon} />
      </View>
    )
  }
  return null;
}

const styles = StyleSheet.create({
  iconContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.65)',
  },
  lockIcon: {
    position: 'absolute',
    paddingTop: 10,
  },
})
export default ProjectLockOverlay;